// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["defaultVendors-node_modules_date-io_moment_build_index_esm_js-node_modules_fortawesome_pro-li-124279"], function() { return __webpack_require__("./app.ts"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
